const {get, post, put} = require('./src/scrape-url-request');
const rp = require('request-promise')

function ScraperAPIClient(api_key) {
  return {
    get: (url, options) => get(url, options, api_key),
    post: (url, options) => post(url, options, api_key),
    put: (url, options) => put(url, options, api_key),
    account: () => rp({
      url: 'https://api.scraperapi.com/account',
      method: 'GET',
      json: true,
      qs: {
        api_key
      }
    })
  };
}

module.exports = ScraperAPIClient
